import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaGooglePlay, FaApple, FaChevronRight } from 'react-icons/fa';

const Footer = () => {
    const { t } = useTranslation();

    const footerSections = [
        {
            title: t('footer.application'),
            items: [
                { title: t('footer.buyer'), link: "#" },
                { title: t('footer.producer'), link: "#" },
                { title: t('footer.transporter'), link: "#" },
                { title: t('footer.censusAgent'), link: "#" },
                { title: t('footer.website'), link: "#" },
            ],
        },
        {
            title: t('footer.services'),
            items: [
                { title: t('footer.marketPrices'), link: "/consulter/" },
                { title: t('footer.findTransporter'), link: "/recherche_trans/0" },
            ],
        },
        {
            title: t('footer.features'),
            items: [
                { title: t('footer.makePurchases'), link: "/list_products" },
                { title: t('footer.makeClaim'), link: "/quotation_list" },
                { title: t('footer.productPriceRequest'), link: "/consulter/" },
                { title: t('footer.viewPurchases'), link: "/cart" },
                { title: t('footer.viewOrders'), link: "/commandes" },
            ],
        },
    ];

    return (
        <footer className="bg-gradient-to-b from-[#0F3D24] to-[#14532D] text-white">
            {/* Main Footer */}
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
                    
                    {/* Brand Section */}
                    <div className="lg:col-span-1 space-y-4">
                        <img 
                            className="h-10 w-auto" 
                            src="/assets/logo_white.png" 
                            alt={t('footer.logoAlt')} 
                        />
                        <p className="text-gray-300 text-sm leading-relaxed max-w-xs">
                            {t("text_footer_logo")}
                        </p>
                        {/* Social Icons - Optional */}
                        <div className="flex space-x-3 pt-2">
                            <a href="#" className="text-gray-400 hover:text-[#FACC15] transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                                </svg>
                            </a>
                            <a href="#" className="text-gray-400 hover:text-[#FACC15] transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                                </svg>
                            </a>
                            <a href="#" className="text-gray-400 hover:text-[#FACC15] transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Footer Sections */}
                    {footerSections.map((section, index) => (
                        <div key={index} className="space-y-3">
                            <h3 className="text-[#FACC15] font-semibold text-sm uppercase tracking-wider">
                                {section.title}
                            </h3>
                            <ul className="space-y-2">
                                {section.items.map((item, idx) => (
                                    <li key={idx}>
                                        <Link 
                                            to={item.link} 
                                            className="text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 text-sm flex items-center group"
                                        >
                                            <FaChevronRight className="w-2 h-2 mr-2 text-[#FACC15] opacity-0 group-hover:opacity-100 transition-opacity" />
                                            {item.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    {/* Download Section */}
                    <div className="lg:col-span-1 space-y-4">
                        <h3 className="text-[#FACC15] font-semibold text-sm uppercase tracking-wider">
                            {t('footer.downloadOn')}
                        </h3>
                        <div className="space-y-3">
                            {/* Google Play Button */}
                            <button className="w-full sm:w-auto bg-white hover:bg-gray-100 text-black rounded-lg px-4 py-2.5 flex items-center space-x-3 transition-all duration-200 shadow-lg hover:shadow-xl">
                                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-8.495 4.886L14.499 12.707zM3.66 1.282L14.498 12.12l2.302-2.302L5.303 1.282zM16.804 8.947l-8.495-4.886 8.495 4.886z"/>
                                </svg>
                                <div className="text-left">
                                    <span className="text-[10px] leading-none block">{t('footer.getItOn')}</span>
                                    <span className="text-sm font-semibold leading-none">{t('footer.playStore')}</span>
                                </div>
                            </button>

                            {/* App Store Button - Uncommented */}
                            <button className="w-full sm:w-auto bg-black hover:bg-gray-900 text-white rounded-lg px-4 py-2.5 flex items-center space-x-3 transition-all duration-200 shadow-lg hover:shadow-xl">
                                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                                </svg>
                                <div className="text-left">
                                    <span className="text-[10px] leading-none block">{t('footer.getItOn')}</span>
                                    <span className="text-sm font-semibold leading-none">{t('footer.appStore')}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-[#15803D]/30">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
                        <p className="text-[#83ECAC] text-sm text-center sm:text-left">
                            &copy; {new Date().getFullYear()} AgroMarket. {t("droit")}
                        </p>
                        <div className="flex space-x-6 text-sm">
                            <Link to="#" className="text-[#83ECAC] hover:text-white transition-colors">
                                {t("condition")}
                            </Link>
                            <Link to="#" className="text-[#83ECAC] hover:text-white transition-colors">
                                {t("politique")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;